import { createSlice } from '@reduxjs/toolkit';

import { updateSearchParams } from '../common/reducers/updateSearchParams.reducers';

import { INITIAL_ARCHIVED_DOCUMENTS_STATE } from './archived.state';

const slice = createSlice({
  name: 'archivedDocuments',
  initialState: INITIAL_ARCHIVED_DOCUMENTS_STATE,
  reducers: {
    updateSearchParams,
  },
});

export const ArchivedDocumentsActions = slice.actions;

export const documentArchivedReducer = slice.reducer;
